import React, { lazy } from 'react';
import { motion } from 'framer-motion';
export function SolutionSection() {
  return <section className="py-16 md:py-24 bg-transparent" data-id="element-197">
      <div className="container mx-auto px-4 max-w-4xl text-center" data-id="element-198">
        <div className="mb-10" data-id="element-199">
          <span className="inline-block px-6 py-2.5 mb-5 rounded-full border border-white/40 bg-[#4A553F] text-white font-semibold tracking-[0.18em] uppercase text-xs" data-id="element-200">
            LA SOLUCIÓN QUE ESPERABAS — UN SISTEMA TODO EN UNO
          </span>
          <h2 className="font-heading md:text-5xl font-bold text-[#2f3a2c] mb-6 max-w-3xl mx-auto text-[24px]" data-id="element-201">
            El único sistema que tu gestión de capacitaciones necesita para
            funcionar con{' '}
            <span className="text-[#5C6851] italic" data-id="element-202">
              orden, respaldo y control real durante todo el año
            </span>
          </h2>
        </div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.96
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="mb-10" data-id="element-203">
          <img src="https://cdn.magicpatterns.com/uploads/aUSifw2rJ3KwxdQpZ897WN/listo.webp" alt="Sistema Maestro de Capacitaciones HyS" width={672} height={672} loading="lazy" decoding="async" sizes="(max-width: 768px) 100vw, 672px" className="w-full h-auto max-w-2xl mx-auto rounded-2xl shadow-xl shadow-navy/5 border border-slate-100" data-id="element-204" />
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="bg-white/60 border border-amber-100 text-[#2f3a2c] rounded-3xl p-8 md:p-10 shadow-sm" data-id="element-205">
          <p className="md:text-xl font-medium text-slate-700 text-[16px]" data-id="element-206">
            No es un simple pack de PDFs. Es un Sistema Maestro con las 52
            semanas del año resueltas y todas las herramientas listas para
            implementar desde el primer día.
          </p>
        </motion.div>
      </div>
    </section>;
}